<template>
    <div>
        <van-cell-group title="用户信息">
            <van-cell title="头像" center>
                <template #default>
                    <van-image round fit="cover" width="50px" height="50px" :src="$store.state.userInfo.avatar"/>
                </template>
            </van-cell>

            <van-cell title="昵称" :value="$store.state.userInfo.nickname"></van-cell>
            <van-cell title="性别" :value="$store.state.systemEnum['company']['user']['gender'][$store.state.userInfo.gender]"></van-cell>
            <van-cell class="long-value-cell" title="ID" :value="$store.state.userInfo.id"></van-cell>
            <van-cell title="分组" :value="$store.state.userInfo.user_group_name"></van-cell>
            <van-cell title="等级" :value="$store.state.userInfo.level_name"></van-cell>
        </van-cell-group>

        <van-cell-group title="操作">
            <van-cell v-if="$store.state.userInfo.is_bind_phone" title="修改手机号" :value="$store.state.userInfo.phone_desensitization" is-link @click="$router.push({ name : 'ModifyPhone' })" />
            <van-cell v-else title="绑定手机号" is-link @click="$router.push({ name : 'BindPhone' })" />
            <van-cell title="修改支付密码" is-link @click="modifyPaymentPassword" />
            <van-cell title="忘记支付密码" is-link @click="forgetPaymentPassword" />
            <van-cell title="开票信息" is-link @click="$router.push({name: 'InvoiceTitleInfo'})" />
            <van-cell title="微信绑定" :is-link="!$store.state.userInfo.is_bind_wechat" :value="$store.state.userInfo.is_bind_wechat ? '已绑定' : '未绑定'" @click="bindWechat" />
        </van-cell-group>
    </div>
</template>

<script>
    import api from "../../assets/js/api";
    import auth from "../../assets/js/auth";

    export default {
        name: "Info",
        methods : {
            modifyPaymentPassword(){
                let self = this;
                api.request('/user/is_payment_password').then(res => {
                    if(!res.data.is_payment_pasword){
                        self.$beilinTools.setPaymentPasswordPopup().open();
                        self.$toast('您还未设置支付密码，请设置');
                    }else{
                        self.$router.push({ name : 'ModifyPaymentPassword' });
                    }
                });
            },
            forgetPaymentPassword(){
                let self = this;
                api.request('/user/is_payment_password').then(res => {
                    if(!res.data.is_payment_pasword){
                        self.$beilinTools.setPaymentPasswordPopup().open();
                        self.$toast('您还未设置支付密码，请设置');
                    }else{
                        self.$router.push({ name : 'ForgetPaymentPassword' });
                    }
                });
            },
            bindWechat(){
                let self = this;
                if(self.$store.state.userInfo.is_bind_wechat) return;
                let companyId = self.$route.params.companyId;
                let redirectUrl = window.location.origin + `/${companyId}/user/index`;
                redirectUrl = encodeURIComponent(redirectUrl);

                let param = ''
                if (!(/^[0-9]+.?[0-9]*$/.test(companyId))) {
                    param = `global_company_wechat_id=${companyId}`
                } else {
                    param = `global_company_id=${companyId}`
                }
                window.location = `${api.REQUEST_URL_PREFIX}/user/bind_wechat?${param}&callback_url=${redirectUrl}&api_token=${auth.getAuthInfo().api_token}`;
            },//todo
        },
    }
</script>

<style scoped lang="scss">
	.long-value-cell.van-cell {

		.van-cell__value {
			flex: 4;
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/user/Info.vue